 
import { ClassificacaoPageProps } from "./types";
import { useClassificacao } from "./hooks/useClassificacao";
import ExerciseCard, {
  IconX,
  IconCheck,
  IconUndo,
} from "./components/ExerciseCard";
import { classificacaoStyles } from "./styles";
import Skeleton from "../../components/ui/Skeleton";

export default function ClassificacaoPage({
  exercises: externalExercises,
}: ClassificacaoPageProps) {
  const {
    exercises,
    visibleExercises,
    currentIndex,
    yesCount,
    noCount,
    isDone,
    loading,
    handleSwipe,
    handleButtonSwipe,
    handleUndo,
    handleRestart,
  } = useClassificacao({ initialExercises: externalExercises });

  return (
    <div className="mx-auto max-w-7xl px-3 sm:px-4 py-4 sm:py-6 md:px-6 2xl:px-10">
      <style>{classificacaoStyles}</style>
      <div className="flex w-full justify-center">
        <div className="fs-root">
          {!isDone ? (
            <>
              {loading ? (
                <div className="fs-stack">
                  {[0, 1, 2].map((idx) => (
                    <div
                      key={idx}
                      className={`fs-card ${
                        idx === 0 ? "is-top" : idx === 1 ? "behind-1" : "behind-2"
                      }`}
                    >
                      <div className="fs-card-image-wrapper">
                        <Skeleton className="w-full h-full" />
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="fs-stack">
                  {visibleExercises.map((ex, idx) => (
                    <ExerciseCard
                      key={ex.id}
                      exercise={ex}
                      stackPosition={idx}
                      onSwipe={idx === 0 ? handleSwipe : () => {}}
                    />
                  ))}
                </div>
              )}

              <div className="fs-actions">
                <button
                  className="fs-btn fs-btn-undo"
                  onClick={handleUndo}
                  title="Desfazer"
                >
                  <IconUndo />
                </button>
                <button
                  className="fs-btn fs-btn-no"
                  onClick={() => handleButtonSwipe("no")}
                  title="Rejeitar"
                >
                  <IconX />
                </button>
                <button
                  className="fs-btn fs-btn-yes"
                  onClick={() => handleButtonSwipe("yes")}
                  title="Aprovar"
                >
                  <IconCheck />
                </button>
              </div>

              <div className="fs-score-row">
                <div className="fs-score-item">
                  <IconX />
                  <span
                    className="fs-score-num"
                    style={{ color: "var(--c-no)" }}
                  >
                    {noCount}
                  </span>
                  <span>rejeitados</span>
                </div>
                <div className="fs-score-item">
                  <IconCheck />
                  <span
                    className="fs-score-num"
                    style={{ color: "var(--c-yes)" }}
                  >
                    {yesCount}
                  </span>
                  <span>aprovados</span>
                </div>
              </div>
            </>
          ) : (
            <div className="fs-done">
              <div className="fs-done-title">CONCLUÍDO!</div>
              <p className="fs-done-sub">
                Você classificou todos os exercícios desta sessão.
              </p>
              <div className="fs-done-stats">
                <div className="fs-done-stat">
                  <span
                    className="fs-done-stat-num"
                    style={{ color: "var(--c-yes)" }}
                  >
                    {yesCount}
                  </span>
                  <span className="fs-done-stat-label">Aprovados</span>
                </div>
                <div className="fs-done-stat">
                  <span
                    className="fs-done-stat-num"
                    style={{ color: "var(--c-no)" }}
                  >
                    {noCount}
                  </span>
                  <span className="fs-done-stat-label">Rejeitados</span>
                </div>
              </div>
            <button className="fs-btn-restart" onClick={handleRestart}>
              Continuar
            </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}